import { laptopMediumMax, laptopMediumMin, tabletMin } from '@propertypal/shared/src/constants/mediaQueries';
import bg from '@propertypal/shared/src/resources/bg/crawfords-farm-bg.png';
import styled, { css } from 'styled-components';
import { Container as PropertyImportantPlaces } from '../PropertyImportantPlaces.style.pn';

const MAX_WIDTH = 1260;

export const DetailsBg = styled.div`
  background-image: url('${bg.src}');
  box-shadow:
    inset 0px 11px 20px -10px #000,
    inset 0px -11px 20px -10px #000;
  height: auto;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding: 16px;
  align-items: center;

  @media (${tabletMin}) {
    padding: 32px;
  }

  @supports (-webkit-touch-callout: none) {
    background-attachment: scroll;
    transform: translate3d(0, 0, 0);
  }

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }
`;

export const DetailsContent = styled.div`
  margin: 0 auto;
  max-width: ${MAX_WIDTH}px;
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;

  @media (max-width: ${MAX_WIDTH + 30}px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

const ContentStyles = css`
  width: 100%;
  background: ${({ theme }) => theme.background};
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  padding: 16px;
  height: fit-content;
  align-self: center;

  @media (${tabletMin}) {
    padding: 32px;
  }
`;

export const DetailsContentMain = styled.div`
  ${ContentStyles}
  @media (${laptopMediumMin}) {
    margin-right: 12px;
    max-width: 66.6%;
    flex-basis: 66.6%;
  }

  ${PropertyImportantPlaces} {
    border-bottom-width: 0px;
  }
`;

export const DetailsContentAdditional = styled.div`
  ${ContentStyles}
  @media (${laptopMediumMin}) {
    margin-left: 12px;
    flex-basis: 33.3%;
    max-width: 33.3%;
  }
  @media (${laptopMediumMax}) {
    margin-top: 32px;
  }
`;
